import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import AgreementRepository from '@/repositories/agreementRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useAgreementListStore = defineStore({
    id: 'agreementList',
    state: () => ({
        agreementList: [],
    }),
    getters: {},
    actions: {
        reset() {
            this.agreementList = [];
        },
        /**
         * ユーザー同意済規定一覧取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getAgreementListAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const agreementRepository = new AgreementRepository();
            try {
                const response = await agreementRepository.getAgreementListApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.agreementList = response.data.List;
                this.agreementList.map(function (e) {
                    e.AgreementDt = e.AgreementDt.split(' ')[0];
                });
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
